// reactstrap components
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { Fragment } from "react";
import NumberFormat from "react-number-format";
import useAuth from "../../Hooks/useAuth";
import { ArrowRight } from "react-bootstrap-icons";
import { TypeLogin } from "../../types";

const Login = () => {
  const {
    logInUser,
    isLoading,
    handleChange,
    userCredentials,
    errorMessage,
    disable,
    logOutFromOldDevice,
    setLogOutFromOldDevice,
    handleClickYes
  } = useAuth();
  return (
    <Fragment>
      <Col lg="5" md="7">
        <Card className="bg-secondary shadow border-0">
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Sign in with credentials</small>
            </div>
            <Form
              role="form"
              onSubmit={() => logInUser(false)}
            >
              <FormGroup style={{ position: "relative" }}>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend" className="pointer">
                    <InputGroupText>
                      <i className="fas fa-user-shield"></i>
                    </InputGroupText>
                  </InputGroupAddon>
                  <Input
                    type="text"
                    placeholder="EMP code"
                    autoComplete=""
                    id="srn"
                    required
                    autoFocus
                    value={userCredentials?.srn}
                    onChange={(e) => handleChange("srn", e.target.value)}
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup style={{ position: "relative" }}>
                <InputGroup className="input-group-alternative">
                  <InputGroupAddon addonType="prepend" className="pointer">
                    <InputGroupText>
                      <i className="fas fa-calendar-day"></i>
                    </InputGroupText>
                  </InputGroupAddon>
                  <NumberFormat
                    placeholder="Password (DD-MM-YYYY)"
                    format="##/##/####"
                    value={userCredentials?.dob}
                    onChange={(e) => handleChange("dob", e.target.value)}
                    className="form-control"
                    required
                  />
                </InputGroup>
              </FormGroup>
              <div>
                {errorMessage && (
                  <p className="text-danger mt-0 rounded small">
                    *{errorMessage}
                  </p>
                )}
              </div>
              <div className="text-center">
                {isLoading ? (
                  <Button
                    className="my-4"
                    color="primary"
                    size="block"
                    type="button"
                  >
                    <div
                      className="spinner-border rounded-circle spinner-border-sm"
                      role="status"
                    >
                      <p className="sr-only">Loading...</p>
                    </div>
                  </Button>
                ) : (
                  <Button
                    className="my-4"
                    color="primary"
                    size="block"
                    type="submit"
                    id="submitForm"
                    disabled={disable}
                  >
                    Sign in <i className="fas fa-sign-in-alt pl-2"></i>
                  </Button>
                )}
              </div>
            </Form>
          </CardBody>
        </Card>
      </Col>

      <Modal isOpen={logOutFromOldDevice} toggle={() => setLogOutFromOldDevice(false)} >
        <div className='mx-4 mt-5 d-flex item-center' >
          <div className="flex flex-col">
            <div className="text-xl font-bold tracking-tight d-flex justify-content-between text-dark mb-1">
              <span>User is Already Logged In</span>
              <i className={"fas fa-sign-out-alt mr-2 ml-3 fa-2x text-xl text-danger"}></i>
            </div>
            <p className="text-muted">
              You must logout from old device first. Do you want to logout from old device and login here?
            </p>
          </div>

          {/*<span style={{ fontSize: "18px" }}>
                You must logout from old device first. Do you want to logout from old device and login here?
                </span> */}
        </div>
        <ModalFooter>
          <Button color="secondary" onClick={() => setLogOutFromOldDevice(false)}>NO</Button>
          <Button
            color="danger"
            onClick={(e) =>
              handleClickYes(e)
            }>
            YES
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>

  );
};

export default Login;
